<mat-card appearance="outlined" class="order-summary-card">
  <ng-container *ngIf="!removeHeader">
    <mat-card-header>
      <mat-card-title>{{ title }}</mat-card-title>
      <ng-container *ngIf="editable && !editing && (uiLineItems$ | async)">
        <button
          data-action="orders:edit-using-order-confirmation:start"
          class="edit"
          mat-icon-button
          matTooltip="Edit"
          (click)="edit()"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </ng-container>
    </mat-card-header>
    <mat-divider />
  </ng-container>

  <mat-card-content>
    <ng-container *ngIf="!editing; else editingTemplate">
      <ng-container *ngIf="orderState$ | async as orderState">
        <store-order-summary
          [orderItems]="orderState.orderItems"
          [taxOptions]="orderState.taxOptions"
          [duration]="orderState.duration"
          [loading]="orderState.loading"
          [expanded]="openExpansionPanel$ | async"
          [showPricing]="showPricing$ | async"
          [partnerId]="partnerId"
          [marketId]="marketId"
          [estimatedTotal]="orderState.estimatedTotal"
        />
      </ng-container>
    </ng-container>
  </mat-card-content>
</mat-card>

<ng-template #editingTemplate>
  <div class="product-list">
    <ng-container *ngFor="let uiLineItem of editingItems; let liIndex = index">
      <ng-container [formGroup]="formForLineItems.controls[liIndex]">
        <div class="list-item">
          @if (!enableEditBillingSchedule) {
            <mat-icon *ngIf="editingItems.length > 0" class="delete-line-item" (click)="deleteLineItem(liIndex)">
              clear
            </mat-icon>
          }
          <div class="list-item__body">
            <div class="left-section">
              <store-order-item-compact
                class="item-label"
                [item]="{
                  name: uiLineItem.name + (uiLineItem.editionName ? ' | ' + uiLineItem.editionName : ''),
                  iconUrl: uiLineItem.iconUrl,
                  billingPeriod: uiLineItem.lineItem?.billingPeriod,
                  revenuePeriod: uiLineItem.lineItem?.currentRevenue?.revenueComponents[0]?.period,
                  formattedPrice: '',
                  headerImageUrl: '',
                  tagline: '',
                }"
                [showPricing]="false"
              />
              <mat-form-field
                class="quantity-control"
                [matTooltip]="uiLineItem.isMultiActivatable ? '' : ('FRONTEND.SALES_UI.QUANTITY_DISABLED' | translate)"
              >
                <mat-label>{{ 'FRONTEND.SALES_UI.QUANTITY' | translate }} *</mat-label>
                <input
                  matInput
                  #input
                  type="number"
                  step="1"
                  formControlName="quantity"
                  placeholder="{{ 'FRONTEND.SALES_UI.QUANTITY' | translate }}"
                />
                <mat-error *ngIf="formForLineItems.controls[liIndex]['controls'].quantity.hasError('min')">
                  {{ 'FRONTEND.SALES_UI.QUANTITY_ERROR' | translate }}
                </mat-error>
              </mat-form-field>
              @if (enableEditBillingSchedule) {
                <button mat-icon-button [matMenuTriggerFor]="menu" class="kebob-menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  @if (contractStart$ | async; as contractStart) {
                    <button mat-menu-item (click)="onEditBillingSchedule(liIndex, contractStart)">
                      {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.EDIT_BILLING_TERMS' | translate }}
                    </button>
                    <button
                      *ngIf="uiLineItem.isMultiActivatable && uiLineItem.lineItem?.billingPeriod"
                      mat-menu-item
                      (click)="onAddBillingSchedule(liIndex, contractStart)"
                    >
                      {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.ADD_BILLING_TERMS' | translate }}
                    </button>
                  }
                  <button *ngIf="editingItems.length > 0" mat-menu-item (click)="deleteLineItem(liIndex)">
                    {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.REMOVE_ITEM' | translate }}
                  </button>
                </mat-menu>
              }
            </div>
            <div class="right-section">
              <ng-container
                *ngFor="
                  let revenueComponent of uiLineItem.lineItem?.currentRevenue?.revenueComponents || [];
                  let rcIndex = index;
                  let last = last
                "
              >
                <!-- <glxy-currency-field
                  [value]="revenueComponent?.value / 100 || 0"
                  [currencyCode]="uiLineItem.lineItem?.currencyCode || defaultDisplayCurrency"
                  [minimumValue]="'0'"
                  [suffixText]="revenueComponent?.period | revenuePeriodToFrequency"
                  [formControl]="
                    formForLineItems.controls[liIndex]['controls']?.revenueComponents.controls[rcIndex]['controls']
                      ?.revenue
                  "
                >
                </glxy-currency-field>
                @if (uiLineItem.lineItem?.currentRevenue?.revenueComponents.length > 1) {
                  <span class="delete-icon">
                    <button
                      mat-button
                      color="warn"
                      (click)="deleteRevenueRow($event, liIndex, rcIndex)"
                      class="mobile-delete"
                    >
                      {{ 'FRONTEND.SALES_UI.REMOVE' | translate }}
                    </button>
                  </span>
                } -->
                <sales-ui-sales-order-edit-price
                  #editPriceComponent
                  [revenueComponent]="revenueComponent"
                  [canEditPeriod]="rcIndex === 0"
                  [allowNegativeValues]="allowNegativeValues"
                  [currencyCode]="uiLineItem.lineItem?.currencyCode || defaultDisplayCurrency"
                  [allowDelete]="uiLineItem.lineItem?.currentRevenue?.revenueComponents.length > 1"
                  [form]="formForLineItems.controls[liIndex]['controls']?.revenueComponents.controls[rcIndex]"
                  (delete)="deleteRevenueRow($event, liIndex, rcIndex)"
                />

                <ng-container *ngIf="last === false">
                  <mat-divider />
                </ng-container>
              </ng-container>
              <div class="add-revenue-container">
                <div class="no-revenue-error" *ngIf="hasNoRevenue(uiLineItem, liIndex)">
                  <mat-error>
                    {{ 'FRONTEND.SALES_UI.PRICING.REVENUE_REQUIRED' | translate }}
                  </mat-error>
                </div>
                <div (click)="addRevenueRow(liIndex)">
                  <span><mat-icon class="add-button">add</mat-icon></span>
                  <span class="add-button">
                    {{ 'FRONTEND.SALES_UI.PRICING.ADD_ROW' | translate }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <mat-checkbox *ngIf="createRetailSubscriptions" class="invoice-control" formControlName="shouldInvoice">
          {{ 'FRONTEND.SALES_UI.BILL_FOR_RECURRING_CHARGES' | translate }}
        </mat-checkbox>
      </ng-container>
      <mat-divider />
    </ng-container>
    <div class="add-line-item-container">
      <div (click)="addLineItems()" *ngIf="editingItems?.length > 0; else noLineItems">
        <span><mat-icon class="add-button">add</mat-icon></span>
        <span class="add-button">
          {{ 'FRONTEND.SALES_UI.ADD_ITEMS' | translate }}
        </span>
      </div>
      <ng-template #noLineItems>
        <button mat-flat-button color="primary" (click)="addLineItems()">
          {{ 'FRONTEND.SALES_UI.ADD_ITEMS' | translate }}
        </button>
      </ng-template>
    </div>
  </div>
  <div class="actions" *ngIf="orderId || opportunityId">
    <button mat-stroked-button (click)="cancel()" [disabled]="saving">
      {{ 'FRONTEND.SALES_UI.CANCEL' | translate }}
    </button>
    <ng-container *ngIf="!saving">
      <button
        data-action="orders:edit-using-order-confirmation:save"
        mat-flat-button
        color="primary"
        (click)="save()"
        [disabled]="!this.formForLineItems.valid"
      >
        {{ 'FRONTEND.SALES_UI.SAVE' | translate }}
      </button>
    </ng-container>
    <ng-container *ngIf="saving">
      <div class="saving-button">
        <mat-spinner [diameter]="30" />
      </div>
    </ng-container>
  </div>
</ng-template>
